import React, { useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import { Button, InputText } from '@insurancemenu/imenu-components-lib/dist/components';
import { toJS } from 'mobx';
import SubtitleWithLines from 'components/common/general/SubtitleWithLines';
import { createStyles } from './styles';

interface EnrollFormProps {
  showFullTitle: boolean;
}

const EnrollForm = observer(({ showFullTitle }: EnrollFormProps): JSX.Element => {
  const classes = createStyles();
  // Mobx store
  const {
    enrollModalStore: { form, loading, saveEnrollModalChanges },
    proposalCartStore: { cart },
    domainStore: { closeChoiceModal },
  } = useRootStore();

  const convertedCart = toJS(cart);
  const scrollRef = useRef<HTMLDivElement>(null);

  const onClose = (): void => {
    closeChoiceModal();
    scrollRef.current?.scrollTo(0, 0);
  };

  const onSubmit = (e: React.FormEvent): void => {
    e.preventDefault();
    void saveEnrollModalChanges(convertedCart, onClose);
  };

  return (
    <>
      {!loading && (
        <div ref={scrollRef}>
          <div className={classes.body}>
            {showFullTitle ? (
              <h3 className={classes.modalTitle}>Enroll now</h3>
            ) : (
              <SubtitleWithLines text="Enroll now" />
            )}
            <p className={classes.subtitle}>
              Great! Before we proceed we&apos;ll need to create a secure profile. Please give us an email and
              we&apos;ll email you a secure registration link to choose your plan and get coverage for your company!
            </p>
            <form className={classes.form} onSubmit={onSubmit} id="enroll_form">
              <InputText
                label="Company name"
                name="companyName"
                value={form.fields.companyName.value}
                onChange={form.onFieldChange}
                className={classes.bigInput}
                validationPassed={!form.fields.companyName.unpassedValidationMsg}
                validationMessage={form.fields.companyName.unpassedValidationMsg || ''}
              />
              <div className={classes.inputWrapper}>
                <InputText
                  label="First name"
                  name="firstName"
                  value={form.fields.firstName.value}
                  onChange={form.onFieldChange}
                  className={classes.smallInput}
                  width="50%"
                  validationPassed={!form.fields.firstName.unpassedValidationMsg}
                  validationMessage={form.fields.firstName.unpassedValidationMsg || ''}
                />
                <InputText
                  label="Last name"
                  name="lastName"
                  value={form.fields.lastName.value}
                  onChange={form.onFieldChange}
                  className={classes.smallInput}
                  validationPassed={!form.fields.lastName.unpassedValidationMsg}
                  validationMessage={form.fields.lastName.unpassedValidationMsg || ''}
                />
              </div>
              <InputText
                label="Email"
                name="email"
                value={form.fields.email.value}
                onChange={form.onFieldChange}
                className={classes.bigInput}
                validationPassed={!form.fields.email.unpassedValidationMsg}
                validationMessage={form.fields.email.unpassedValidationMsg || ''}
              />
            </form>
          </div>
          <footer className={classes.footer}>
            <div className={classes.actionsBlock}>
              <Button type="outlined" onClick={onClose} size="large">
                Cancel
              </Button>
              <Button
                color="primary"
                htmlType="submit"
                size="large"
                htmlForm="enroll_form"
                disabled={!form.isFormValid()}
              >
                Submit
              </Button>
            </div>
          </footer>
        </div>
      )}
    </>
  );
});

export default EnrollForm;
